import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DxCheckBoxModule, DxDataGridModule } from 'devextreme-angular';
import { ConfirmBoxDirectiveModule } from 'src/app/directives';
import { OpenDoorPageRoutingModule } from './open-door-routing.module';
import { OpenDoorPage } from './open-door.page';
import { OpenDoorService } from './service/open-door.service';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		OpenDoorPageRoutingModule,
		DxDataGridModule,
		ConfirmBoxDirectiveModule,
		DxCheckBoxModule,
	],
	declarations: [OpenDoorPage],
	providers: [OpenDoorService],
})
export class OpenDoorPageModule {}
